import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
// Install global fetch/axios interceptors BEFORE any component mounts.
import "@/lib/apiClient";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
